import React, { useState, useEffect } from 'react';
import debounce from 'lodash.debounce';
import { TextField } from '@material-ui/core';
import styles from './style.module.scss';
import GlobalSearchResults from './GlobalSearchResults';
import { connect } from 'react-redux';
let performSearch = null;
const GlobalSearch = props => {
  const { history, isSearchActive } = props;

  const [searchTerm, setSearchTerm] = useState('');
  const [searchResults, setSearchResults] = useState(null);

  performSearch = debounce(searchTerm => {
    fetch(`${process.env.BASE_URL}/search?orgId=${2}&term=${searchTerm}`)
      .then((response) => response.json())
      .then((data) => { setSearchResults(data.results) });
  }, 1050);

  useEffect(() => {
    if (!isSearchActive) setSearchTerm('')
  }, [isSearchActive])

  const handleChange = ({ target }) => {
    const { value: searchTerm } = target;

    if (!searchTerm.length)
      return clearSearchResults();

    setSearchTerm(searchTerm);
    performSearch(searchTerm);
  };

  const clearSearchResults = () => {
    setSearchTerm('');
    setSearchResults(null);
  };

  return (
    <div className={styles.searchGroupWrapper}>
      {
        isSearchActive &&
        <input autoFocus={true} className={styles.searchInput} name="search" placeholder="Search..." value={searchTerm} onChange={handleChange} />
      }
      {
        // Added an additional check here for searchTerm in order to remove results when input is cleared.
        // TODO: Consider finding a way to cancel requests when search input field is cleared.
        (searchTerm && searchResults) &&
        <GlobalSearchResults
          searchResults={searchResults}
          clearSearchResults={clearSearchResults}
          history={history} />
      }
    </div>
  );
};

export default connect(({ isSearchActive }) => ({ isSearchActive }))(GlobalSearch);
